import React from 'react';
import { useLocation } from 'react-router-dom';
import cx from 'clsx';

import { useSwitch, useTheme } from '@/hooks';
import { IconClose } from '@/assets/download';

import { DownloadBtn } from './DownloadBtn';
import styles from './index.module.scss';

export const DownloadGuide = () => {
  const { on, turnOff } = useSwitch(true);
  const { isDark } = useTheme();
  const location = useLocation();
  const isProfile = location.pathname.includes('profile');

  if (!on)
    return (
      <div className={styles.singleBtn}>
        <DownloadBtn />
      </div>
    );
  return (
    <div className={cx(styles.container, isDark && styles.isDark)}>
      <div className={styles.closeBtn} onClick={() => turnOff()}>
        <IconClose />
      </div>
      <div className={styles.content}>
        <span className={styles.contentText}>
          {isProfile
            ? 'Get an more comprehensive view of on-chain net worth or change of the address in DeBank APP'
            : 'Get an accurate view of your on-chain net worth anytime in Debank APP, which brings you a smoother experience.'}
        </span>
        <DownloadBtn />
      </div>
    </div>
  );
};
